<template>
  <div>
    <div align="left">
      <br />
      <h5 class="font-weight-bold text-primary">Services PaxelBox</h5>
      <br />
    </div>
    <b-card class="text-left">
      <b>Create New Services PaxelBox</b>
      <br />
      <b-row class="mt-4">
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Judul"
            label-for="input-1"
          >
            <input
              id="input-1"
              placeholder="Judul"
              v-validate="'required'"
              v-model="title_id"
              data-vv-as="Judul"
              name="title_id"
              class="form-control"
            />
            <b-form-invalid-feedback id="input-name-feedback">{{
              veeErrors.first("title_id")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Title"
            label-for="input-1"
          >
            <input
              id="input-1"
              placeholder="Title"
              v-validate="'required'"
              v-model="title_en"
              data-vv-as="Title"
              name="title_en"
              class="form-control"
            />
            <b-form-invalid-feedback id="input-name-feedback">{{
              veeErrors.first("title_en")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label-class="control-label"
            class="required"
            label="Banner Image (Desktop)"
            label-for="input-1"
          >
            <b-card body-class="py-2 px-2">
              <card-body>
                <b-row>
                  <b-col class="text-primary mt-2">
                    <i class="fas fa-paperclip"></i>&nbsp;
                    <b>Banner Image (Desktop)</b>
                    <sup class="text-secondary pl-3"
                      >(2 Mb)&nbsp;(1920px x 700px)</sup
                    >
                  </b-col>
                  <b-col md="4" class="text-right" align="right">
                    <input
                      type="file"
                      ref="fileDesktop"
                      name="fileDesktop"
                      v-validate="
                        'required|minimalDimensions:1920,700|ratiolDimensions:96,35|size:2000|ext:jpg,png,gif,jpeg,svg,webp'
                      "
                      style="display: none"
                      v-on:change="onChangeFileDesktop()"
                    />
                    <b-button
                      @click="$refs.fileDesktop.click()"
                      v-show="!fileDesktop"
                      variant="primary"
                      class="ml-5"
                      >Select File</b-button
                    >
                    <b-button
                      v-show="fileDesktop"
                      variant="primary"
                      @click="modalDesktop = !modalDesktop"
                      class="mr-2"
                      >Preview</b-button
                    >
                    <b-button
                      @click="$refs.fileDesktop.click()"
                      v-show="fileDesktop"
                      variant="outline-primary"
                      class
                      >Change File</b-button
                    >
                  </b-col>
                </b-row>
              </card-body>
            </b-card>
            <p
              class="text-danger"
              style="width: 100%; margin-top: 0.25rem; font-size: 80%"
            >
              {{ veeErrors.first("fileDesktop") }}
            </p>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label-class="control-label"
            class="required"
            label="Banner Image (Mobile)"
            label-for="input-1"
          >
            <b-card body-class="py-2 px-2">
              <card-body>
                <b-row>
                  <b-col class="text-primary mt-2">
                    <i class="fas fa-paperclip"></i>&nbsp;
                    <b>Banner Image (Mobile)</b>
                    <sup class="text-secondary pl-3"
                      >(2 Mb)&nbsp;(640px x 400px)</sup
                    >
                  </b-col>
                  <b-col md="4" class="text-right" align="right">
                    <input
                      type="file"
                      ref="fileMobile"
                      name="fileMobile"
                      v-validate="
                        'required|minimalDimensions:640,400|ratiolDimensions:64,40|size:2000|ext:jpg,png,gif,jpeg,svg,webp'
                      "
                      style="display: none"
                      @change="onChangeFileMobile()"
                    />
                    <b-button
                      @click="$refs.fileMobile.click()"
                      v-show="!fileMobile"
                      variant="primary"
                      class="ml-5"
                      >Select File</b-button
                    >
                    <b-button
                      v-show="fileMobile"
                      variant="primary"
                      @click="modalMobile = !modalMobile"
                      class="mr-2"
                      >Preview</b-button
                    >
                    <b-button
                      @click="$refs.fileMobile.click()"
                      v-show="fileMobile"
                      variant="outline-primary"
                      class
                      >Change File</b-button
                    >
                  </b-col>
                </b-row>
              </card-body>
            </b-card>
            <p
              class="text-danger"
              style="width: 100%; margin-top: 0.25rem; font-size: 80%"
            >
              {{ veeErrors.first("fileMobile") }}
            </p>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Deskripsi Service (Bahasa)"
            label-for="input-1"
          >
            <ckeditor
              :editor="editor"
              :config="editorConfig"
              v-model="description_id"
              tag-name="textarea"
              placeholder="Deskripsi Service Bahasa"
              v-validate="'required'"
              name="description_id"
              data-vv-as="Deskripsi Service Bahasa"
              class="form-control"
            ></ckeditor>
            <p
              class="text-danger"
              style="width: 100%; margin-top: 0.25rem; font-size: 80%"
            >
              {{ veeErrors.first("description_id") }}
            </p>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Deskripsi Service (English)"
            label-for="input-1"
          >
            <ckeditor
              :editor="editor"
              :config="editorConfig"
              v-model="description_en"
              tag-name="textarea"
              placeholder="Deskripsi Service English"
              v-validate="'required'"
              name="description_en"
              data-vv-as="Deskripsi Service English"
              class="form-control"
            ></ckeditor>
            <p
              class="text-danger"
              style="width: 100%; margin-top: 0.25rem; font-size: 80%"
            >
              {{ veeErrors.first("description_en") }}
            </p>
          </b-form-group>
        </b-col>
        <b-col></b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            label="Video Embed URL"
            label-for="input-1"
          >
            <input
              id="input-1"
              placeholder="Video Embed URL"
              v-validate="'url: {require_protocol: true }'"
              v-model="video_url"
              data-vv-as="Video Embed URL"
              name="video_url"
              class="form-control"
            />
            <b-form-invalid-feedback id="input-name-feedback">{{
              veeErrors.first("video_url")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col></b-row
      >
      <br />
      <label> How to Use / Guide</label>

      <div class="form-group" v-for="(input, k) in step" :key="k">
        <b-row>
          <b-col md="6">
            <b-form-group
              id="fieldset-1"
              label-class="control-label"
              class="required"
              label-for="input-1"
            >
              Step {{ k + 1 }} Deskripsi Bahasa
              <br />
              <br />
              <ckeditor
                :editor="editor"
                :config="editorConfig"
                v-model="input.data.deskripsi_id"
                tag-name="textarea"
                placeholder="Step Deskripsi Bahasa"
                v-validate="'required'"
                :name="'deskripsi_id' + k"
                data-vv-as="Step Deskripsi Bahasa"
                class="form-control"
              ></ckeditor>
              <p
                class="text-danger"
                style="width: 100%; margin-top: 0.25rem; font-size: 80%"
              >
                {{ veeErrors.first("deskripsi_id" + k) }}
              </p>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              id="fieldset-1"
              label-class="control-label"
              class="required"
              label-for="input-1"
            >
              Step {{ k + 1 }} Deskripsi English
              <br />
              <br />
              <ckeditor
                :editor="editor"
                :config="editorConfig"
                v-model="input.data.deskripsi_en"
                tag-name="textarea"
                placeholder="Step Deskripsi English"
                v-validate="'required'"
                :name="'deskripsi_en' + k"
                data-vv-as="Step Deskripsi English"
                class="form-control"
              ></ckeditor>
              <p
                class="text-danger"
                style="width: 100%; margin-top: 0.25rem; font-size: 80%"
              >
                {{ veeErrors.first("deskripsi_en" + k) }}
              </p>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-button
              block
              variant="danger"
              @click="remove(k)"
              v-show="k || (!k && step.length > 1)"
              >Hapus</b-button
            >
          </b-col>
          <b-col md="6">
            <b-form-group id="fieldset-1" label-for="input-1"
              >Step {{ k + 1 }} Image
            </b-form-group>

            <b-card body-class="py-2 px-2">
              <card-body>
                <b-row>
                  <b-col md="6" class="text-primary mt-2">
                    <i class="fas fa-paperclip"></i>
                    &nbsp; File
                    {{
                      !step[k].data.image ? "Photo" : step[k].data.image.name
                    }}
                    <br />(/.png/.jpg/.gif)
                    <sup class="text-secondary">(2000 Kb)</sup>
                  </b-col>
                  <b-col class="text-right" align="right">
                    <input
                      type="file"
                      ref="datas"
                      :name="'support_file' + k"
                      data-vv-as="Support File"
                      v-validate="'required|size:2000|ext:jpg,png,jpeg,gif'"
                      style="display: none"
                      v-on:change="onChangeimage(k)"
                    />
                    <b-button
                      @click="$refs.datas[k].click()"
                      v-show="!step[k].data.image"
                      variant="primary"
                      class="ml-5"
                      >Pilih File</b-button
                    >
                    <b-button
                      @click="$refs.datas[k].click()"
                      v-show="step[k].data.image"
                      variant="outline-primary"
                      class="mr-2"
                      >Ubah File</b-button
                    >
                    <b-button
                      @click="openStepImage(k)"
                      v-show="step[k].data.image"
                      variant="primary"
                      class
                      >Pratinjau File</b-button
                    >
                  </b-col>
                </b-row>
              </card-body>
            </b-card>
            <p
              class="text-danger"
              style="width: 100%; margin-top: 0.25rem; font-size: 80%"
            >
              {{ veeErrors.first("support_file" + k) }}
            </p>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6"> </b-col>
          <b-col md="6">
            <b-button
              block
              variant="outline-primary"
              @click="add(k)"
              v-show="k == step.length - 1"
            >
              <i class="fas fa-plus"></i> Tambah Step
            </b-button>
          </b-col>
        </b-row>
      </div>
      <b-row>
        <b-col md="6">
          <b-form-group id="fieldset-1" label="With Button" label-for="input-1">
            <b-form-radio-group
              id="radio-group-1"
              v-model="is_active"
              :options="options1"
              name="radio-options"
            ></b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-show="is_active">
        <br />
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Button Text (Bahasa)"
            label-for="input-1"
          >
            <input
              :disabled="is_active == false"
              v-model="text_button_id"
              v-validate="'required'"
              data-vv-as="Button Text Bahasa"
              name="text_button_id"
              class="form-control"
              placeholder="Button Text in Bahasa"
            />
            <b-form-invalid-feedback id="input-question_id-feedback">{{
              veeErrors.first("text_button_id")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Button Text (English)"
            label-for="input-1"
          >
            <input
              :disabled="is_active == false"
              v-model="text_button_en"
              v-validate="'required'"
              data-vv-as="Button Text English"
              name="text_button_en"
              class="form-control"
              placeholder="Button Text in English"
            />
            <b-form-invalid-feedback id="input-question_id-feedback">{{
              veeErrors.first("text_button_en")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col></b-col>
      </b-row>
      <b-row v-show="is_active">
        <br />
        <b-col md="6">
          <b-form-group id="fieldset-1" label="Button Url" label-for="input-1">
            <b-form-radio-group
              id="radio-group-url"
              v-model="button_is_article"
              :options="options3"
              name="radio-url"
            ></b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-show="is_active">
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Article"
            label-for="input-1"
            v-show="button_is_article == true"
          >
            <vue-multiselect
              id="ajax2"
              open-direction="bottom"
              v-model="article_url"
              v-validate="
                button_is_article == true && is_active == true ? 'required' : ''
              "
              data-vv-as="Article Url"
              name="article_url"
              :preserve-search="true"
              :options="dataArticle"
              :custom-label="nameWithLang"
              placeholder="Type to search Article"
              track-by="id"
              label="slug"
              class="text-capitalize"
              :loading="isLoadingArticle"
              :searchable="true"
              @search-change="asyncFindArticle"
            >
              <template slot="option" slot-scope="props">
                <div class="option__desc">
                  <span class="option__title">{{ props.option.title.id }}</span>
                </div>
              </template>
            </vue-multiselect>
            <p
              class="text-danger"
              style="width: 100%; margin-top: 0.25rem; font-size: 80%"
            >
              {{ veeErrors.first("article_url") }}
            </p>
          </b-form-group>

          <b-form-group
            id="fieldset-1"
            label="Other URL"
            label-for="input-1"
            v-show="button_is_article == false"
          >
            <input
              v-model="other_url"
              v-validate="
                button_is_article == false && is_active == true
                  ? 'required|url: {require_protocol: true }'
                  : 'url: {require_protocol: true }'
              "
              name="other_url"
              data-vv-as="Other URL"
              class="form-control"
              placeholder="URL"
            />
            <p
              class="text-danger"
              style="width: 100%; margin-top: 0.25rem; font-size: 80%"
            >
              {{ veeErrors.first("other_url") }}
            </p>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="With Download Button"
            label-for="input-1"
          >
            <b-form-radio-group
              id="download-button"
              v-model="is_with_download_button"
              :options="options1"
              name="download-button"
            ></b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-show="is_with_download_button">
        <b-col md="6">
          <b-form-group id="fieldset-1" label="Play Store" label-for="input-1">
            <b-card body-class="py-2 px-2">
              <card-body>
                <b-row>
                  <b-col class="text-primary mt-2">
                    <i class="fas fa-paperclip"></i>&nbsp;
                    <b>Icon Download Play Store</b>
                    <sup class="text-secondary pl-3"
                      >(2 Mb)&nbsp;(160px x 50px)</sup
                    >
                  </b-col>
                  <b-col md="4" class="text-right" align="right">
                    <input
                      type="file"
                      ref="play_store_icon"
                      name="playstoreicon"
                      v-validate="
                        is_with_download_button == true
                          ? 'required|minimalDimensions:160,50|ratiolDimensions:16,5|size:2000|ext:jpg,png,gif,jpeg,svg,webp'
                          : 'minimalDimensions:160,50|ratiolDimensions:16,5|size:2000|ext:jpg,png,gif,jpeg,svg,webp'
                      "
                      style="display: none"
                      @change="onChangeFilePlayStore()"
                    />
                    <b-button
                      @click="$refs.play_store_icon.click()"
                      v-show="!play_store_icon"
                      variant="primary"
                      class="ml-5"
                      >Select Icon</b-button
                    >
                    <b-button
                      v-show="play_store_icon"
                      variant="primary"
                      @click="modalPlayStore = !modalPlayStore"
                      class="mr-2"
                      >Preview</b-button
                    >
                    <b-button
                      @click="$refs.play_store_icon.click()"
                      v-show="play_store_icon"
                      variant="outline-primary"
                      class
                      >Change File</b-button
                    >
                  </b-col>
                </b-row>
              </card-body>
            </b-card>
            <p
              class="text-danger"
              style="width: 100%; margin-top: 0.25rem; font-size: 80%"
            >
              {{ veeErrors.first("playstoreicon") }}
            </p>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group id="fieldset-1" label="App Store" label-for="input-1">
            <b-card body-class="py-2 px-2">
              <card-body>
                <b-row>
                  <b-col class="text-primary mt-2">
                    <i class="fas fa-paperclip"></i>&nbsp;
                    <b>Icon Download App Store</b>
                    <sup class="text-secondary pl-3"
                      >(2 Mb)&nbsp;(160px x 50px)</sup
                    >
                  </b-col>
                  <b-col md="4" class="text-right" align="right">
                    <input
                      type="file"
                      ref="app_store_icon"
                      name="appstoreicon"
                      v-validate="
                        is_with_download_button == true
                          ? 'required|minimalDimensions:160,50|ratiolDimensions:16,5|size:2000|ext:jpg,png,gif,jpeg,svg,webp'
                          : 'minimalDimensions:160,50|ratiolDimensions:16,5|size:2000|ext:jpg,png,gif,jpeg,svg,webp'
                      "
                      style="display: none"
                      @change="onChangeFileAppStore()"
                    />
                    <b-button
                      @click="$refs.app_store_icon.click()"
                      v-show="!app_store_icon"
                      variant="primary"
                      class="ml-5"
                      >Select Icon</b-button
                    >
                    <b-button
                      v-show="app_store_icon"
                      variant="primary"
                      @click="modalAppStore = !modalAppStore"
                      class="mr-2"
                      >Preview</b-button
                    >
                    <b-button
                      @click="$refs.app_store_icon.click()"
                      v-show="app_store_icon"
                      variant="outline-primary"
                      class
                      >Change File</b-button
                    >
                  </b-col>
                </b-row>
              </card-body>
            </b-card>
            <p
              class="text-danger"
              style="width: 100%; margin-top: 0.25rem; font-size: 80%"
            >
              {{ veeErrors.first("appstoreicon") }}
            </p>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group id="fieldset-1" label-for="input-1">
            <input
              v-model="play_store_url"
              v-validate="
                is_with_download_button == true
                  ? 'required|url: {require_protocol: true }'
                  : 'url: {require_protocol: true }'
              "
              data-vv-as="URL Play Store"
              name="play_store_url"
              class="form-control"
              placeholder="URL Play Store"
            />
            <b-form-invalid-feedback id="input-question_id-feedback">{{
              veeErrors.first("play_store_url")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group id="fieldset-1" label-for="input-1">
            <input
              v-model="app_store_url"
              v-validate="
                is_with_download_button == true
                  ? 'required|url: {require_protocol: true }'
                  : 'url: {require_protocol: true }'
              "
              data-vv-as="URL App Store"
              name="app_store_url"
              class="form-control"
              placeholder="URL App Store"
            />
            <b-form-invalid-feedback id="input-question_id-feedback">{{
              veeErrors.first("app_store_url")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group id="fieldset-1" label="Status" label-for="input-1">
            <b-form-radio-group
              id="radio-group-2"
              v-model="status"
              :options="options2"
              name="radio-status"
            ></b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col>
          <b-form-group id="fieldset-1" label="Period" label-for="input-1">
            <b-form-group id="fieldset-1" label-for="input-1">
              <b-row class="m-0">
                <b-col
                  class="pr-0 pt-1 form-control img-calender-select border-right-0"
                  md="2"
                >
                  <img
                    src="@/assets/ic-calendar-copy-30.svg"
                    width="25px"
                    alt
                    class
                  />
                </b-col>
                <b-col class="px-0">
                  <datepicker
                    input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                    placeholder="Start Date"
                    v-model="period_start"
                    :format="customFormatter"
                    :disabled="is_always_active"
                    :disabledDates="disabledDates"
                  ></datepicker>
                </b-col>
                <b-col align="left" md="1" class="px-0">
                  <b-col
                    class="pt-1 px-4 form-control del-calender-select border-left-0"
                    md="2"
                  >
                    <b-row class="pt-1">
                      <b-col>
                        <b-link
                          @click="resetStardate"
                          style="text-decoration: none"
                        >
                          <i class="text-danger fas fa-times"></i>
                        </b-link>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-col>
              </b-row>
            </b-form-group>
          </b-form-group>
        </b-col>
        <b-col>
          <p class="mt-n2">&nbsp;</p>
          <b-form-group id="fieldset-1" label-for="input-1">
            <b-row class="m-0">
              <b-col
                class="pr-0 pt-1 form-control img-calender-select border-right-0"
                md="2"
              >
                <img
                  src="@/assets/ic-calendar-copy-30.svg"
                  width="25px"
                  alt
                  class
                />
              </b-col>
              <b-col class="px-0">
                <datepicker
                  input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                  placeholder="End Date"
                  v-model="period_end"
                  :format="customFormatter"
                  :disabled="is_always_active"
                  :disabledDates="disabledDates"
                ></datepicker>
              </b-col>
              <b-col align="left" md="1" class="px-0">
                <b-col
                  align="left"
                  class="pt-1 px-4 form-control del-calender-select border-left-0"
                  md="2"
                >
                  <b-row align="left" class="pt-1">
                    <b-col>
                      <b-link
                        @click="resetEnddate"
                        style="text-decoration: none"
                      >
                        <i class="text-danger fas fa-times"></i>
                      </b-link>
                    </b-col>
                  </b-row>
                </b-col>
              </b-col>
            </b-row>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <div class="form-group required font-weight-bold">
        <label class="control-label"></label>
        Required
      </div>
      <b-row class="text-right">
        <b-col>
          <b-button
            variant="primary"
            :disabled="loading"
            @click="post()"
            class="mr-3"
            size="lg"
            >Create</b-button
          >
          <router-link :to="{ name: 'servicesLocker' }">
            <b-button variant="outline-secondary" size="lg">Cancel</b-button>
          </router-link>
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-model="modalMobile" title="Preview Image" size="xl">
      <img v-if="urlMobile" width height="400px" :src="urlMobile" />
    </b-modal>
    <b-modal v-model="modalDesktop" title="Preview Image" size="xl">
      <img v-if="urlDesktop" width height="400px" :src="urlDesktop" />
    </b-modal>
    <b-modal v-model="modalPlayStore" title="Preview Image" size="xl">
      <img v-if="urlPlayStore" width height="400px" :src="urlPlayStore" />
    </b-modal>
    <b-modal v-model="modalAppStore" title="Preview Image" size="xl">
      <img v-if="urlAppStore" width height="400px" :src="urlAppStore" />
    </b-modal>
    <b-modal v-model="modalStep" title="Preview Image" size="xl">
      <img v-if="url_step" width height="400px" :src="url_step" />
    </b-modal>
  </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { mixInCkeditor } from "@/mixin/mixInCkeditor";
import Datepicker from "vuejs-datepicker";
export default {
  mixins: [mixInCkeditor],
  components: {
    Datepicker,
  },
  data() {
    return {
      is_with_download_button: false,
      modalStep: false,
      url_step: "",
      loading: false,
      widthMobile: null,
      heightMobile: null,
      widthDesktop: null,
      heightDesktop: null,
      name: null,
      description_id: null,
      description_en: null,
      title_id: null,
      title_en: null,
      video_url: '',
      sub_heading_id: null,
      sub_heading_id: null,
      sub_heading_en: null,
      article_url: null,
      other_url: null,
      text_button_id: null,
      text_button_en: null,
      status: "publish",
      is_active: false,
      InputImageMobile: false,
      InputImageDesktop: false,
      is_always_active: false,
      button_is_article: true,
      period_start: "",
      period_end: "",
      modalMobile: false,
      modalDesktop: false,
      fileDesktop: "",
      fileDesktopJPG: "",
      fileMobile: "",
      fileMobileJPG: "",
      urlMobile: "",
      isLoadingArticle: false,
      searchTermArticle: "",
      urlDesktop: "",
      modalPlayStore: false,
      modalAppStore: false,
      play_store_icon: "",
      play_store_url: "",
      app_store_icon: "",
      app_store_url: "",
      urlAppStore: "",
      urlPlayStore: "",
      dataArticle: [],
      options: [],
      options1: [
        { text: "No", value: false },
        { text: "Yes", value: true },
      ],
      options3: [
        { text: "Article", value: true },
        { text: "Other URL", value: false },
      ],
      options2: [
        { text: "Publish", value: "publish" },
        { text: "Archive", value: "archive" },
      ],
      disabledDates: {
        to: new Date(Date.now() - 8640000),
      },
      step: [
        {
          data: {
            deskripsi_id: "",
            deskripsi_en: "",
            image: "",
            url: "",
          },
        },
      ],
      editor: ClassicEditor,
      loading: false,
      judul: "",
      title: "",
      name: "",
      category_en: "",
    };
  },
  beforeCreate() {
    const formData = new FormData();
    formData.append("search_param", "");
    formData.append("limit", 10);
    formData.append("page", 1);
    formData.append("status", "publish");
    formData.append("status", "highlight");
    this.$store
      .dispatch("ArticleModule/getArticles2", formData)
      .then((response) => {
        this.dataArticle = response.data.data.results;
        this.isLoadingArticle = false;
      })
      .catch((error) => {
        this.$swal({
          type: "error",
          title: "Oops...",
          html: error.response.data.message,
          showConfirmButton: false,
          timer: 1500,
        });
        this.isLoadingArticle = false;
      });
  },
  methods: {
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    openStepImage(index) {
      this.modalStep = true;
      this.url_step = this.step[index].data.url;
    },
    resetStardate() {
      this.period_start = "";
    },
    resetEnddate() {
      this.period_end = "";
    },
    asyncFindArticle(query) {
      this.isLoadingArticle = true;
      this.searchTermArticle = query;
      this.getWorksAsync();
    },
    getWorksAsync: _.debounce(function () {
      const article = this.searchTermArticle.toLowerCase();
      const formData = new FormData();
      formData.append("search_param", article);
      formData.append("limit", 10);
      formData.append("page", 1);
      formData.append("status", "publish");
      formData.append("status", "highlight");
      this.$store
        .dispatch("ArticleModule/getArticles2", formData)
        .then((response) => {
          this.dataArticle = response.data.data.results;
          this.isLoadingArticle = false;
        })
        .catch((error) => {
          this.$swal({
            type: "error",
            title: "Oops...",
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
          this.isLoadingArticle = false;
        });
    }, 1000),
    add(index) {
      this.step.push({
        data: {
          deskripsi_id: "",
          deskripsi_en: "",
          image: "",
          url: "",
        },
      });
    },
    remove(index) {
      this.step.splice(index, 1);
    },
    onChangeimage(id) {
      const file = this.$refs.datas[id].files[0];
      this.step[id].data.image = this.$refs.datas[id].files[0];
      const input = this.$refs.datas[id];
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;
          this.step[id].data.url = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    post() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading = true;
          const formData = new FormData();
          formData.append("image_desktop_jpg", this.fileDesktop);
          formData.append("image_mobile_jpg", this.fileMobile);
          formData.append("title_id", this.title_id);
          formData.append("title_en", this.title_en);
          formData.append("description_id", this.description_id);
          formData.append("description_en", this.description_en);
          formData.append("sub_heading_id", this.sub_heading_id);
          formData.append("sub_heading_en", this.sub_heading_en);
          formData.append("text_button_id", this.text_button_id);
          formData.append("text_button_en", this.text_button_en);
          formData.append(
            "is_with_download_button",
            this.is_with_download_button
          );
          formData.append("play_store_icon", this.play_store_icon);
          formData.append("play_store_url", this.play_store_url);
          formData.append("app_store_icon", this.app_store_icon);
          formData.append("app_store_url", this.app_store_url);
          formData.append("video_url", this.video_url);
          if (this.step) {
            $.each(this.step, (index, value) => {
              formData.append("guide[sequence]", index);
              formData.append(
                `guide[description_id][${index}]`,
                value.data.deskripsi_id
              );
              formData.append(
                `guide[description_en][${index}]`,
                value.data.deskripsi_en
              );
              formData.append(`guide[image][${index}]`, value.data.image);
            });
          } else {
            formData.append("stage", this.step);
          }

          formData.append("is_article", this.button_is_article);
          if (this.button_is_article && this.is_active) {
            formData.append("article_id", this.article_url.id);
          } else {
            formData.append("article_id", this.article_url);
          }
          formData.append("other_url", this.other_url);
          formData.append("is_with_button", this.is_active);
          if (this.period_start != "" && this.period_end == "") {
            const start = this.period_start.toJSON().slice(0, 10);
            formData.append("period_start", start);
            formData.append("period_end", this.period_end);
          }
          if (this.period_end != "" && this.period_start == "") {
            const end = this.period_end.toJSON().slice(0, 10);
            formData.append("period_start", this.period_start);
            formData.append("period_end", end);
          }
          if (this.period_start != "" && this.period_end != "") {
            const start = this.period_start.toJSON().slice(0, 10);
            const end = this.period_end.toJSON().slice(0, 10);

            formData.append("period_start", start);
            formData.append("period_end", end);
          }
          if (this.period_start == "" && this.period_end == "") {
            formData.append("period_start", this.period_start);
            formData.append("period_end", this.period_end);
          }
          formData.append("status", this.status);
          this.$store
            .dispatch("servicesLockerModule/postServicesMicrosite", formData)
            .then((response) => {
              this.loading = false;
              this.$router.push({ name: "servicesLocker" });
              this.$swal({
                type: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                timer: 1500,
              });
              console.log(response);
            })
            .catch((error) => {
              this.loading = false;
              var message = "";
              $.each(error.response.data.data, (key, data) => {
                message += data + "<br/>";
              });
              this.$swal({
                type: "error",
                title: "Oops...",
                html: message,
                showConfirmButton: false,
                timer: 1500,
              });
              this.serverError = error.response.data;
              console.log(error);
            });
        } else {
          this.$swal({
            type: "error",
            title: "Oops...",
            text: this.$validator.errors.all(),
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });
    },
    onChangeFileDesktop() {
      this.fileDesktop = this.$refs.fileDesktop.files[0];
      const input = this.$refs.fileDesktop;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.onload = () => {
            this.widthDesktop = img.width;
            this.heightDesktop = img.height;
          };
          img.src = e.target.result;
          this.urlDesktop = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    onChangeFileMobile() {
      this.fileMobile = this.$refs.fileMobile.files[0];
      const input = this.$refs.fileMobile;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.onload = () => {
            this.widthMobile = img.width;
            this.heightMobile = img.height;
          };
          img.src = e.target.result;
          this.urlMobile = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    onChangeFileAppStore() {
      this.app_store_icon = this.$refs.app_store_icon.files[0];
      const input = this.$refs.app_store_icon;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;
          this.urlAppStore = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    onChangeFilePlayStore() {
      this.play_store_icon = this.$refs.play_store_icon.files[0];
      const input = this.$refs.play_store_icon;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;
          this.urlPlayStore = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
  },
};
</script>

<style>
</style>
